export default function RankingSliderIcon({ className = "", onClick = null }) {
  return (
    <>
      <svg
        className={className}
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 326.48 326.48"
      >
        <path
          d="M326.48,0v.05h-.31C146.04.05.01,146.07.01,326.2v.27h-.01V21.64C0,9.69,9.69,0,21.64,0h304.84Z"
          style={{ fill: 'var(--app-background-color)' }}
        />
      </svg>
    </>
  );
}